import { api } from "../lib/api";

// urlBase64 → Uint8Array (needed by pushManager.subscribe)
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function currentPushState() {
  if (!(await isPushSupported())) return { supported: false, permission: "unsupported", subscribed: false };
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return {
    supported: true,
    permission: Notification.permission,
    subscribed: Boolean(sub),
    endpoint: sub?.endpoint || null,
  };
}

export async function subscribeToPush() {
  if (!(await isPushSupported())) throw new Error("Push not supported in this browser");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission denied");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  const key = urlBase64ToUint8Array(data.public_key);
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: key,
  });
  const s = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: s.endpoint, keys: s.keys });
  return s;
}

export async function unsubscribeFromPush() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  if (!sub) return true;
  try { await api.delete(`/push/subscribe?endpoint=${encodeURIComponent(sub.endpoint)}`); } catch {}
  return sub.unsubscribe();
}
